import { render } from "./CoursesPageFour.vue?vue&type=template&id=01faa6f9"
import script from "./CoursesPageFour.vue?vue&type=script&lang=js"
export * from "./CoursesPageFour.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__